import React, { useEffect, useRef, useState } from 'react';
import logo from '../assets/images/xpanceLabel.png';
import PrimaryButton from './PrimaryButton';
import { toast } from 'react-toastify';

const pageStyle = `
  @page {
    size: 50mm 75mm;
    margin: 0;
  }

  body {
    text-transform: uppercase;
  }

  @media all {
    .pageBreak {
      display: none;
    }
  }

  @media print {
    body {
      font-family: "Courier Prime", monospace;
      margin-top: 0;
      margin-right: 0;
    }
    .bodyBox{
      padding: 5px !important;
      page-break-before: always; 
    }
    .orderNoAndTime{
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      padding-bottom: 4px;
    }
    .orderNo{
      font-weight: 500;
      margin: 0;
      font-size: 16px;
    }
    .readyTime{
      font-weight: 500;
      margin: 0;
      font-size: 16px;
      text-align: right;
    }
    .productName{
      font-weight: 500;
      margin: 0;
    }
    ul {
      margin: 0;
      padding: 5px;
    }
    li {
      margin: 0;
    }
    .pageBreak {
      page-break-before: always;
    }
    .footer {
      width: 100%;
      text-align: center;
      font-size: 10px;
      font-weight: bold;
      padding: 0;
      margin: 0;
      display: flex;
      bottom: 0;
      justify-content: center;
      align-items: center;
      text-transform: lowercase !important;
      margin-top: auto;
      position: absolute;
      gap: 2px;
      right: 10%;
      left: 50%;
      transform: translateX(-50%);
    }

  }
`;

const ContentToPrint = React.forwardRef(({ productName, addons, orderNo, orderSequence, readyTime, ordersType, takeAway }, ref) => {

  const addonFontSize = React.useMemo(() => {
    if (!addons) return '12px'; // default
    if (addons?.length > 9) return '8px';
    if (addons.length > 7) return '9px';
    if (addons.length > 5) return '10px';
    return '12px';
  }, [addons]);

  const productFontSize = React.useMemo(() => {
    if (!productName) return '14px';
    if (addons?.length > 9) return '12px';
    return '14px';
  }, [productName, addons]);

  return (
    <div className='bodyBox' ref={ref}>
      <div>
        <div className='orderNoAndTime'>
          <p className='orderNo'>#{orderSequence}{orderNo}</p>
          <p className='readyTime'>
            ({takeAway === 'TAKE-AWAY' ? 'T' : ordersType === 'PICKUP' ? 'P' : ordersType === 'DELIVERY' ? 'D' : ''})
          </p>
          {/* <p className='readyTime'>{readyTime}</p> */}
        </div>
        <p style={{ fontSize: productFontSize }} className='productName'>{productName}</p>
        {addons && addons?.length > 0 && (
          <ul>
            {addons?.map((addon, index) => (
              <li style={{ fontSize: addonFontSize }} key={index}> {addon?.selectedValue}</li>
            ))}
          </ul>
        )}
        <p className='readyTime'>{readyTime}</p>
      </div>
      <p className='footer'>
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10" height="10" viewBox="0 0 24 24"><path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"></path></svg>
        xpansecoffee
      </p>
    </div>
  );
}
);

const LabelPrinter = ({ orders, orderDetail }) => {
  const contentRefs = useRef([]);
  const [dataArr, setDataArr] = useState([]);

  useEffect(() => {
    if (orders) {
      const sortedOrderItems = orders.orderItems.sort((a, b) => {
        if (a.product.classType === 'BEVERAGE' && b.product.classType !== 'BEVERAGE') {
          return -1;
        }
        if (a.product.classType !== 'BEVERAGE' && b.product.classType === 'BEVERAGE') {
          return 1;
        }
        return 0;
      });

      const updatedDataArr = [];
      sortedOrderItems.forEach((orderItem) => {
        for (let i = 0; i < orderItem.quantity; i++) {
          updatedDataArr.push(orderItem);
        }
      });
      setDataArr(updatedDataArr);
    }
  }, [orders]);

  const printContent = () => {
    // toast.success("KOT printed!", { autoClose: 3000 });
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const printDocument = iframe.contentWindow || iframe.contentDocument;
    const doc = printDocument.document || printDocument;
    doc.open();
    doc.write('<html><head><style>');
    doc.write(pageStyle);
    doc.write('</style></head><body>');
    dataArr.forEach((order, index) => {
      const content = contentRefs.current[index];
      doc.write(content.outerHTML);
      if (index < dataArr.length - 1) {
        doc.write('<div class="pageBreak"></div>');
      }
    });
    doc.write('</body></html>');
    doc.close();
    iframe.focus();
    iframe.contentWindow.print();
  };

  // const addons = [
  //   {
  //     selectedValue: "Regular Milk"
  //   },
  //   {
  //     selectedValue: "Single Shot"
  //   },
  //   {
  //     selectedValue: "Large"
  //   },
  //   {
  //     selectedValue: "Mustard Sauce"
  //   },
  //   {
  //     selectedValue: "Thousand Island Sauce"
  //   },
  //   {
  //     selectedValue: "Mayo Sauce"
  //   },
  //   {
  //     selectedValue: "Tandoori Sauce"
  //   },
  //   {
  //     selectedValue: "Extra Cheese"
  //   },
  //   {
  //     selectedValue: "Extra Onion"
  //   },
  //   {
  //     selectedValue: "Extra Tomato"
  //   },
  //   {
  //     selectedValue: "Extra Jalapenos"
  //   },
  // ]

  return (
    <>
      <div style={{ display: 'none' }}>
        {dataArr.map((order, index) => (
          <ContentToPrint
            key={index}
            ref={(ref) => (contentRefs.current[index] = ref)}
            productName={order.product.name}
            // addons={addons}
            addons={order.addons}
            orderNo={orderDetail.order_no}
            orderSequence={orderDetail.order_sequence}
            readyTime={orderDetail.readyTime}
            orderSerialNo={order.orderSerialNo}
            ordersType={orderDetail.ordersType}
            takeAway={orderDetail.pickupOption}
          />
        ))}
      </div>
      <PrimaryButton onClick={printContent} disabledTitle={'Printing'} title={'Print Label'} style={{ borderRadius: '30px' }} />
    </>
  );
};

export default LabelPrinter;
